import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/* Layout */

// 公共路由
export const constantRoutes = [
    {
        path: '/',
        redirect: '/index',
        component: (resolve) => require(['@/components/Main'], resolve),
        meta: {
            title: '家博览会',
        },
        children: [
            {
                path: '/index',
                component: (resolve) => require(['@/pages/Center/index'], resolve),
                hidden: true,
                meta: {
                    title: '家博览会',
                }
            },
        ]
    },
    {
        path: '/404',
        component: (resolve) => require(['@/components/error/404'], resolve),
        hidden: true
    },
    {
        path: '/401',
        component: (resolve) => require(['@/components/error/401'], resolve),
        hidden: true
    }
];

export default new Router({
    mode: 'hash', // 去掉url中的#
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})
